const GRID_SIZE = 126;
const SURFACE_MARGIN = 15;
const SURFACE_WIDTH = GRID_SIZE * 9;
const SURFACE_HEIGHT = GRID_SIZE * 6;
const VIEWBOX_WIDTH = SURFACE_WIDTH;
const VIEWBOX_HEIGHT = SURFACE_HEIGHT;

export default {
  modal: {
    GRID_SIZE,
    SURFACE_MARGIN,
    SURFACE_WIDTH,
    SURFACE_HEIGHT,
    VIEWBOX_WIDTH,
    VIEWBOX_HEIGHT,
  },
  inline: {
    SURFACE_WIDTH: 728,
    LINE_HEIGHT: 90,
  },
};
